import _sfc_main from "./GenericSelectorTile2.mjs";
/* empty css                      */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.mjs";
const GenericSelectorTile = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-a0d82d4f"]]);
export {
  GenericSelectorTile as default
};
//# sourceMappingURL=GenericSelectorTile.mjs.map
